export const PADDING_SMALL = 'small';
export const PADDING_BIG = 'big';

export const PADDING_SIZES = [PADDING_SMALL, PADDING_BIG];
